// src/pages/dashboard/components/ScheduledActivities.js
import React, { useState, useEffect } from 'react';

const ScheduledActivities = () => {
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    // Simulate API call to fetch scheduled activities
    const fetchActivities = async () => {
      const response = await fetch('/api/scheduled-activities'); // Replace with real API endpoint
      const data = await response.json();
      setActivities(data);
    };

    fetchActivities();
  }, []);

  return (
    <div>
      <h3>Scheduled Activities</h3>
      <ul>
        {activities.map((activity) => (
          <li key={activity.Id}>
            Task: {activity.Task}, Robot: {activity.RobotId}, Time: {activity.ScheduledTime}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ScheduledActivities;
